// extracted by mini-css-extract-plugin
module.exports = {"underlineLink":"PlantTreeSection_underlineLink__epOCA","leftAlign":"PlantTreeSection_leftAlign__6l4q2"};